import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Tv, Store, GraduationCap } from "lucide-react";

function Rail({ title, icon, to, items, render, testid }) {
  const Icon = icon;
  return (
    <section data-testid={testid}>
      <div className="flex items-center justify-between mb-2">
        <h3 className="display text-xl font-bold flex items-center gap-2"><Icon size={20} /> {title}</h3>
        <Link to={to} className="text-xs underline">See all →</Link>
      </div>
      <div className="flex flex-nowrap gap-3 overflow-x-auto scroll-smooth snap-x snap-mandatory no-scrollbar pb-2">
        {items.length ? items.map(render) : <div className="text-sm text-slate-500 py-4">Nothing here yet.</div>}
      </div>
    </section>
  );
}

export default function DiscoveryRails() {
  const [tv, setTv] = useState([]);
  const [offers, setOffers] = useState([]);
  const [courses, setCourses] = useState([]);
  useEffect(() => {
    api.get("/tv/content").then(r => setTv(r.data.slice(0, 10))).catch(() => {});
    api.get("/store/products").then(r => setOffers(r.data.filter(p => p.mrp > p.selling_price).slice(0, 10))).catch(() => {});
    api.get("/tv/content").then(r => setCourses(r.data.filter(c => c.content_type === "COURSE" || c.content_type === "NOTE").slice(0, 10))).catch(() => {});
  }, []);
  return (
    <section className="max-w-7xl mx-auto px-6 py-10 space-y-8">
      <Rail title="Trending Ponderr TV Channels" icon={Tv} to="/tv" items={tv} testid="rail-tv"
        render={c => <Link key={c.content_id} to="/tv" className="snap-start w-[280px] sm:w-[310px] flex-shrink-0 flex flex-col justify-between nb-card bg-white p-3">
          <div className="h-24 bg-[#0F1020] text-white rounded grid place-items-center text-xs mb-1">▶ {c.subject || "Lesson"}</div>
          <div className="font-bold text-sm break-words overflow-hidden text-ellipsis line-clamp-2">{c.title}</div><div className="text-xs opacity-60">{c.board} {c.grade}</div></Link>} />
      <Rail title="Trending Store Offers & Bundles" icon={Store} to="/store" items={offers} testid="rail-store"
        render={p => <Link key={p.product_id} to={`/store/vendor/${p.vendor_id}`} className="snap-start w-[220px] sm:w-[240px] flex-shrink-0 nb-card bg-[#FDE047] p-3">
          <div className="font-bold text-sm break-words overflow-hidden text-ellipsis line-clamp-2">{p.title}</div><div className="mono">₹{p.selling_price} <span className="line-through opacity-50 text-xs">₹{p.mrp}</span></div></Link>} />
      <Rail title="Featured Contributor Courses & Notes" icon={GraduationCap} to="/tv" items={courses} testid="rail-courses"
        render={c => <Link key={c.content_id} to="/tv" className="snap-start w-[280px] sm:w-[310px] flex-shrink-0 flex flex-col justify-between nb-card bg-[#C4B5FD] p-3">
          <div className="font-bold text-sm break-words overflow-hidden text-ellipsis line-clamp-2">{c.title}</div><div className="text-xs opacity-70">{c.board} {c.grade} · {c.subject}</div></Link>} />
    </section>
  );
}
